module.exports = __webpack_public_path__ + "static/img/01.0011c8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/docs/001/01.jpg
// module id = AHXm
// module chunks = 1